$(document).ready(function () {
    const triggerModal = (clickedSlide) => {
      clickedSlide.classList.add('active');
      const modal = document.getElementById('showroom-data-capture-modal');
      if (modal) {
        modal.classList.add('active');
        const closeHandler = (event) => {
          if (
            !event.target.closest('.showroom-data-capture-modal__close') &&
            event.target.closest('.showroom-data-capture-modal__card')
          ) return;
          modal.classList.remove('active');
          clickedSlide.classList.remove('active');
          modal.removeEventListener('click', closeHandler);
        };
        modal.addEventListener('click', closeHandler);
      }
    };


    const retailerCards = document.querySelectorAll('.showroom-info-card-item--retailer');
    retailerCards.forEach((card) => {
      card.addEventListener('click', function (event) {
        const clickedCard = event.currentTarget;
        triggerModal(clickedCard);
      });
    });

    const dataPins = document.querySelectorAll('[data-pin]');
    dataPins.forEach((pin) => {
        pin.addEventListener('click', function (event) {
            // prevent default link behavior if the pin is an anchor
            if (pin.tagName.toLowerCase() === 'a') {
                event.preventDefault();
            }
            const clickedPin = event.currentTarget;
            triggerModal(clickedPin);
        });
    });
});